import { cn } from '@/lib/utils';
import { FunctionComponent, PropsWithChildren } from 'react';

export const Label: FunctionComponent<PropsWithChildren & { isCollapsed?: boolean }> = ({ children, isCollapsed }) => {
  return (
    <div
      className={cn(
        'relative duration-200 flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-[450] text-slate-500/70 outline-none ring-sidebar-ring transition-[margin,opa] ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0',
      )}>
      <span className={cn(isCollapsed && 'opacity-0')}>{children}</span>
      {isCollapsed && <span className='w-4 h-[1px] bg-slate-200 dark:bg-stone-800 block absolute'></span>}
    </div>
  );
};
